document.addEventListener("DOMContentLoaded", function () {
  // Select the header active class on menu open
  const header = document.querySelector("header");
  const body = document.querySelector("body");
  const detailsElements = document.querySelectorAll(
    ".header-wrapper .menu-drawer-container"
  );
  const menuShop = document.querySelector(".header__menu-shop");
  const header_bottom = document.querySelector(".header-bottom");
  detailsElements.forEach((detail) => {
    detail.addEventListener("toggle", () => {
      if (
        header_bottom.classList.contains("header-bottom-active") &&
        detail.closest(".header__inline-search-menu")
      ) {
        menuShop.classList.toggle("active");
        header_bottom.classList.remove("header-bottom-active");
      }
      // Only add menu-active if a details element is actually open
      // Skip the header-drawer to avoid conflicts with its closeMenuDrawer logic
      const openNonHeaderDrawer = Array.from(detailsElements).some((d) =>
        d.open && !d.closest('header-drawer')
      );
      if (openNonHeaderDrawer) {
        header.classList.add("menu-active");
        // document.body.classList.add("overflow-hidden");
      } else {
        header.classList.remove("menu-active");
        // document.body.classList.remove("overflow-hidden");
      }
    });
  });

  // close the menu when click on link
  document.querySelectorAll('.menu-drawer__inner-container .menu-drawer__menu li > a').forEach(link => {
    link.addEventListener('click', (event) => {
      event.stopPropagation();
      const headerDrawer = document.querySelector('header-drawer');
      if (!headerDrawer) return;
      const summaryElement = headerDrawer.querySelector('summary');
      headerDrawer.closeMenuDrawer(event, summaryElement);
      document.querySelector('.header').classList.remove('menu-active');
    });
  });

  // bottom menu mobile js
  document
    .querySelectorAll(
      ".header__bottom-mobile-menu .header__menu-main-item-mobile:not(.no-child-links)"
    )
    .forEach(function (menuItem) {
      menuItem.addEventListener("click", function (event) {
        event.preventDefault();
        if (
          document.querySelector(".header").classList.contains("menu-active")
        ) {
          document.querySelector(".header__icon--menu").click();
        }
        document
          .querySelectorAll(".header__menu-main-item-mobile")
          .forEach(function (item) {
            item.classList.remove("bottom-menu-active");
          });
        var clickedLinkId = this.id;
        var matchingSubmenu = document
          .querySelector(".header__bottom-mobile-drawer-content")
          .querySelector(`#${clickedLinkId}`);
        var isSubmenuVisible =
          matchingSubmenu && matchingSubmenu.style.display === "block";
        document
          .querySelectorAll(".header-menu-drawer__submenu")
          .forEach(function (submenu) {
            submenu.style.display = "none";
          });
        document
          .querySelector(".header__bottom-mobile-drawer")
          .classList.remove("opened");
        document.body.classList.remove("overflow-hidden");
        setTimeout(() => {
          if (!isSubmenuVisible && matchingSubmenu) {
            document.documentElement.style.setProperty(
              "--viewport-height",
              `${window.innerHeight}px`
            );
            this.header =
              this.header || document.querySelector(".section-header");
            this.borderOffset =
              this.borderOffset ||
                this.closest(".header-wrapper").classList.contains(
                  "header-wrapper--border-bottom"
                )
                ? 1
                : 0;
            document.documentElement.style.setProperty(
              "--header-bottom-position",
              `${parseInt(
                this.header.getBoundingClientRect().bottom - this.borderOffset
              )}px`
            );
            document
              .querySelector(".header__bottom-mobile-drawer")
              .classList.add("opened");
            document.body.classList.add("overflow-hidden");
            this.classList.add("bottom-menu-active");
            matchingSubmenu.style.display = "block";
          }
        }, 500);
      });
    });

  // bottom menu mobile arrow click js
  if (document.querySelector(".header__bottom-mobile-menu")) {
    document
      .querySelector(".header-bottom .header-bottom-left-arrow")
      .addEventListener("click", function () {
        document
          .querySelector(
            ".header__bottom-mobile-menu .header__inline-menu .list-menu"
          )
          .scrollBy({
            left: -150,
            behavior: "smooth",
          });
      });

    document
      .querySelector(".header-bottom .header-bottom-right-arrow")
      .addEventListener("click", function () {
        document
          .querySelector(
            ".header__bottom-mobile-menu .header__inline-menu .list-menu"
          )
          .scrollBy({
            left: 150,
            behavior: "smooth",
          });
      });
  }

  // shop menu click
  if (menuShop && header_bottom) {
    const shopHover = window.matchMedia("(min-width: 990px) and (hover: hover) and (pointer: fine)");
    const desktopDropdowns = menuShop.closest(".header__inline-search-menu").querySelectorAll("header-menu");
    desktopDropdowns.forEach((dropdown) => {
      dropdown.addEventListener("mouseenter", () => {
        if (!shopHover.matches) return;
        menuShop.classList.remove("active");
        header_bottom.classList.remove("header-bottom-active");
        const details = dropdown.querySelector("details");
        details.open = true;
        details.querySelector("summary").setAttribute("aria-expanded", "true");
      });
      dropdown.addEventListener("mouseleave", () => {
        if (shopHover.matches) dropdown.close();
      });
    });
    menuShop.addEventListener("mouseenter", () => {
      if (!shopHover.matches) return;
      desktopDropdowns.forEach((dropdown) => dropdown.close());
      menuShop.classList.add("active");
      header_bottom.classList.add("header-bottom-active");
    });
    document.addEventListener("mouseover", (event) => {
      if (!shopHover.matches || header_bottom.contains(event.target)) return;
      const otherMenuItem = event.target.closest(".header__inline-search-menu .header__menu-main-item:not(.header__menu-shop)");
      if (header.contains(event.target) && !otherMenuItem) return;
      menuShop.classList.remove("active");
      header_bottom.classList.remove("header-bottom-active");
    });
  }

  // remove shop menu on other menu click
  document.addEventListener("click", function (event) {
    const menuItem = event.target.closest(".header__menu-main-item");
    const shopLink = event.target.closest(".header__menu-shop");
    if (
      menuItem &&
      !shopLink &&
      menuItem.closest(".header__inline-search-menu")
    ) {
      document
        .querySelectorAll(".header__menu-main-item.active")
        .forEach((item) => {
          item.classList.remove("active");
          header_bottom.classList.remove("header-bottom-active");
        });
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    const video = document.querySelector("video");
    if (video && !video.hasAttribute("controls")) {
      video.setAttribute("controls", "controls");
    }
  });
  // Homepage video play/pause on click
  const videoPlayer = document.querySelector(
    ".home-video-with-text .image-with-text__media video"
  );
  const playButton = document.querySelector(
    ".home-video-with-text .block__video-play-button"
  );

  function initializeVideoPlayer() {
    if (videoPlayer) {
      if (playButton) {
        playButton.addEventListener("click", function () {
          videoPlayer.play();
          videoPlayer.setAttribute("controls", true);
          playButton.style.display = "none";
        });
      }
      function togglePlayPause() {
        if (videoPlayer.paused) {
          videoPlayer.play();
          videoPlayer.setAttribute("controls", true);
          if (playButton) playButton.style.display = "none";
        } else {
          videoPlayer.pause();
          videoPlayer.removeAttribute("controls");
          if (playButton) playButton.style.display = "flex";
        }
      }
      videoPlayer.addEventListener("click", togglePlayPause);
      videoPlayer.addEventListener("pause", function () {
        videoPlayer.removeAttribute("controls");
        if (playButton) playButton.style.display = "flex";
      });
    }
  }

  if (window.innerWidth > 991) {
    initializeVideoPlayer();
  }

  window.addEventListener("resize", function () {
    if (window.innerWidth > 991) {
      initializeVideoPlayer();
    }
  });

  //footer mobile js
  if (window.innerWidth < 990) {
    const allBlocks = document.querySelectorAll(".footer-block--menu");
    allBlocks.forEach(function (block) {
      const headings = block.querySelectorAll(".footer-block__heading--wrap");
      headings.forEach(function (heading) {
        heading.addEventListener("click", function (e) {
          e.stopPropagation();
          let menu;
          if (heading.classList.contains("footer-block__heading--wrap-menu-2")) {
            menu = block.querySelector(".footer-second-menu");
          } else {
            menu = block.querySelector(".menu:not(.footer-second-menu)");
          }
          if (!menu) return;
          const isAlreadyOpen = menu.style.display === "block";
          document.querySelectorAll(".footer-block--menu .menu").forEach(function (m) {
            m.style.display = "none";
            m.classList.remove("active");
          });
          document.querySelectorAll(".footer-block__heading--wrap").forEach(function (h) {
            h.classList.remove("footer-menu-active");
          });
          if (!isAlreadyOpen) {
            menu.style.display = "block";
            menu.classList.add("active");
            heading.classList.add("footer-menu-active");
          }
        });
      });
    });
  }

  // Run only if screen width is 750px or larger
  const collectionTabSlider = document.querySelectorAll(
    ".block_collection_tab_col.swiper"
  );

  if (collectionTabSlider) {
    collectionTabSlider.forEach((collection_tab_widget) => {
      new Swiper(collection_tab_widget, {
        slidesPerView: 3,
        spaceBetween: 0,
        loop: false,
        scrollbar: {
          el: collection_tab_widget.querySelector(".block__collection_tab_scrollbar"),
          draggable: true,
          hide: false,
        },
        navigation: {
          nextEl: ".block__collection_tab_next_icon",
          prevEl: ".block__collection_tab_prev_icon",
        },
        breakpoints: {
          750: {
            slidesPerView: 4,
            spaceBetween: 10,
          },
          992: {
            slidesPerView: 5,
            spaceBetween: 10,
          },
          1200: {
            slidesPerView: 6,
            spaceBetween: 10,
          },
          1300: {
            slidesPerView: 7,
            spaceBetween: 10,
          },
        },
      });
    });
  }

  // Collection Tabify Sec Js
  document
    .querySelectorAll(".block_collection_tab_col li")
    .forEach(function (item) {
      item.addEventListener("click", function () {
        var tabId = this.getAttribute("data-tab");

        document
          .querySelectorAll(".block_collection_tab_col li")
          .forEach(function (li) {
            li.classList.remove("active");
          });
        this.closest(".block_collection_tabify_wrapper")
          .querySelectorAll(".block_collection_product")
          .forEach(function (product) {
            product.classList.remove("active");
          });
        this.classList.add("active");
        this.closest(".block_collection_tabify_wrapper")
          .querySelector(`#${tabId}`)
          .classList.add("active");
        requestAnimationFrame(() => {
          recalculateProductCardHeights();
        });
      });
    });

  const tabs = document.querySelectorAll(".collection-tab");
  const viewAllBtn = document.querySelector(".view-all-btn");

  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      // Remove active class from all tabs
      tabs.forEach((t) => t.classList.remove("active"));
      this.classList.add("active");

      // Update button URL
      const newUrl = this.dataset.url;
      if (newUrl && viewAllBtn) {
        viewAllBtn.setAttribute("href", newUrl);
      }
    });
  });

  function recalculateProductCardHeights() {
    document
      .querySelectorAll(
        ".block_collection_tabify_wrapper .product-card-wrapper"
      )
      .forEach(function (subscription_element) {
        subscription_element.style.height = "auto";
        var get_Height = subscription_element.offsetHeight;
        subscription_element.style.height = get_Height + "px";
      });
  }
  recalculateProductCardHeights();
  window.addEventListener("resize", function () {
    recalculateProductCardHeights();
  });

  // product Card Sldier JS
  const bestsellerCardSlider = document.querySelectorAll(
    ".block__best_seller_slider.swiper"
  );

  bestsellerCardSlider &&
    bestsellerCardSlider.forEach((best_seller_card_widget) => {
      new Swiper(best_seller_card_widget, {
        slidesPerView: 3,
        spaceBetween: 25,
        loop: true,
        navigation: {
          nextEl: ".block__best_seller_next_icon",
          prevEl: ".block__best_seller_prev_icon",
        },
        pagination: {
          el: ".swiper-progress-bar",
          type: "progressbar",
        },
        breakpoints: {
          320: {
            slidesPerView: "1",
            spaceBetween: 15,
            autoHeight: true,
          },
          768: {
            slidesPerView: "2",
            spaceBetween: 15,
          },
          992: {
            slidesPerView: "3",
            spaceBetween: 15,
          },
          1300: {
            slidesPerView: "4",
            spaceBetween: 25,
          },
        },
      });
    });

  // Egg Collection Product Slider JS
  const eggCardSlider = document.querySelectorAll(
    ".block__egg_collection_product_slider.swiper"
  );

  eggCardSlider &&
    eggCardSlider.forEach((egg_card_widget) => {
      new Swiper(egg_card_widget, {
        slidesPerView: 3,
        spaceBetween: 25,
        loop: true,
        navigation: {
          nextEl: ".block__egg__collection_product_next_arrow",
          prevEl: ".block__egg__collection_product_prev_arrow",
        },
        breakpoints: {
          320: {
            slidesPerView: "1",
            spaceBetween: 15,
          },
          768: {
            slidesPerView: "2",
            spaceBetween: 15,
          },
          992: {
            slidesPerView: "2",
            spaceBetween: 15,
          },
          1200: {
            slidesPerView: "3",
            spaceBetween: 24,
          },
        },
      });
    });

  // homepage watch and shop slider
  const homepageVideoSlider = document.querySelectorAll(
    ".homepage_video-slider.swiper"
  );
  homepageVideoSlider &&
    homepageVideoSlider.forEach((home_video_widget) => {
      new Swiper(home_video_widget, {
        slidesPerView: 5.4,
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        navigation: {
          nextEl: ".block__homepage-video-next-icon",
          prevEl: ".block__homepage-video-prev-icon",
        },
        breakpoints: {
          320: {
            slidesPerView: "1.5",
            spaceBetween: 0,
          },
          569: {
            slidesPerView: "2",
            spaceBetween: 0,
          },
          768: {
            slidesPerView: "3",
            spaceBetween: 0,
          },
          992: {
            slidesPerView: "4",
            spaceBetween: 0,
          },
          1199: {
            slidesPerView: "4.3",
            spaceBetween: 0,
          },
          1300: {
            slidesPerView: "5.2",
            spaceBetween: 0,
            centeredSlides: true,
          },
        },
      });
    });

  const aboutVideoSlider = document.querySelectorAll(
    ".block__behind_scene_left_box.swiper"
  );
  aboutVideoSlider &&
    aboutVideoSlider.forEach((about_video_widget) => {
      new Swiper(about_video_widget, {
        slidesPerView: 1,
        spaceBetween: 10,
        centeredSlides: false,
        navigation: {
          nextEl: ".block__behind_the_scene_next_icon",
          prevEl: ".block__behind_the_scene_prev_icon",
        },
        loop: true,
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          1300: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
        },
      });
    });

  document
    .querySelectorAll(".block__behind_scene_video_icon")
    .forEach((icon) => {
      icon.addEventListener("click", function () {
        let slide = this.closest(".swiper-slide");
        let video = slide.querySelector(".block__behind_scene_video_col video");

        if (video) {
          if (video.paused) {
            video.play();
            this.style.opacity = "0";
          } else {
            video.pause();
            this.style.opacity = "1";
          }
        }
      });
    });

  // Latest Article Slider Js
  const latestArticleSlider = document.querySelectorAll(
    ".block__latest_article_slider_col.swiper"
  );

  latestArticleSlider &&
    latestArticleSlider.forEach((latest_article_widget) => {
      new Swiper(latest_article_widget, {
        slidesPerView: 3,
        spaceBetween: 25,
        loop: true,
        navigation: {
          nextEl: ".block__latest_artilce_next_icon",
          prevEl: ".block__latest_artilce_prev_icon",
        },
        pagination: {
          el: ".block__latest_swiper-progress-bar",
          type: "progressbar",
        },
        breakpoints: {
          320: {
            slidesPerView: "1",
            spaceBetween: 15,
          },
          768: {
            slidesPerView: "2",
            spaceBetween: 15,
          },
          992: {
            slidesPerView: "3",
            spaceBetween: 15,
          },
          1300: {
            slidesPerView: "3",
            spaceBetween: 25,
          },
        },
      });
    });

  const homepageWorksSliders = document.querySelectorAll(
    ".block__how-works-right.swiper"
  );

  homepageWorksSliders.forEach((slider) => {
    // Create progress bar container
    const progressBar = document.createElement("div");
    progressBar.className = "swiper-progress-bar";
    slider.appendChild(progressBar);

    let swiperInstance = new Swiper(slider, {
      spaceBetween: 24,
      loop: true,
      slidesPerView: 4.5,
      speed: 4000,
      autoplay: {
        delay: 0,
        disableOnInteraction: true,
      },
      freeMode: true,
      freeModeMomentum: true,
      freeModeMomentumRatio: 0.7,
      breakpoints: {
        320: {
          slidesPerView: 2,
          spaceBetween: 0,
          speed: 4000,
        },
        750: {
          slidesPerView: 3,
          spaceBetween: 20,
          speed: 4000,
        },
        1200: {
          slidesPerView: 4.5,
          spaceBetween: 24,
          speed: 4000,
        },
      },
    });

    slider.addEventListener("mouseenter", function () {
      swiperInstance.autoplay.stop();
      progressBar.classList.remove("animate");
    });

    slider.addEventListener("mouseleave", function () {
      swiperInstance.autoplay.start();
      progressBar.classList.add("animate");
    });

    slider.addEventListener("mousemove", function (e) {
      let rect = slider.getBoundingClientRect();
      let midPoint = rect.width / 2;
      let mouseX = e.clientX - rect.left;

      if (mouseX < midPoint - 50) {
        swiperInstance.slidePrev();
      } else if (mouseX > midPoint + 50) {
        swiperInstance.slideNext();
      }
    });

    // Start animation by default
    progressBar.classList.add("animate");
  });

  // homepage trusted families swiper
  const trustedFamiliesSwiper = document.querySelectorAll(
    ".trusted-families-swiper"
  );
  trustedFamiliesSwiper &&
    trustedFamiliesSwiper.forEach((trustedFamiliesSwiperlist) => {
      new Swiper(trustedFamiliesSwiperlist, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        speed: 1500,
        navigation: {
          nextEl: ".block__trusted-next-btn",
          prevEl: ".block__trusted-prev-btn",
        },
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
            autoHeight: true,
          },
          750: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 28,
          },
        },
      });
    });

  let swiperInstance; // Declare globally in this scope
  const sectionPageImageSlider = document.querySelector(".block__image-slider");
  if (sectionPageImageSlider) {
    swiperInstance = new Swiper(sectionPageImageSlider, {
      slidesPerView: 1,
      centeredSlides: true,
      centeredSlidesBounds: true,
      loop: true,
      spaceBetween: 20,
      speed: 1000,
      navigation: {
        nextEl: ".block__image-slider-next-icon",
        prevEl: ".block__image-slider-prev-icon",
      },
      breakpoints: {
        350: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        750: {
          slidesPerView: 1.6,
          spaceBetween: 40,
          centeredSlides: true,
        },
        1200: {
          slidesPerView: 1.6,
          spaceBetween: 20,
          centeredSlides: true,
        },
      },
    });
  }

  // ✅ Attach the resize listener *after* swiperInstance is initialized
  window.addEventListener("resize", () => {
    if (swiperInstance) {
      swiperInstance.update();
    }
  });

  // About Page icon slider
  const abouticonSlider = document.querySelectorAll(
    ".block__about_icon_with_text_slider_col.swiper"
  );

  if (abouticonSlider.length) {
    abouticonSlider.forEach((about_icon_widget) => {
      new Swiper(about_icon_widget, {
        slidesPerView: 3,
        spaceBetween: 10,
        loop: true,
        speed: 3000,
        autoplay: {
          delay: 100,
          disableOnInteraction: false,
        },
        freeMode: false, // Try false to avoid touch conflicts
        grabCursor: true,
        breakpoints: {
          320: {
            slidesPerView: 2,
          },
          400: {
            slidesPerView: 3,
          },
          569: {
            slidesPerView: 4,
          },
        },
      });
    });
  }

  // Article Page Copy Link JS
  const svgElement = document.querySelector("#copy_link_icon");
  const copyTextElement = document.querySelector(".copy_text");

  if (svgElement) {
    svgElement.addEventListener("click", function () {
      const pageUrl = window.location.href;
      navigator.clipboard
        .writeText(pageUrl)
        .then(() => {
          if (copyTextElement) {
            copyTextElement.classList.add("show");
            setTimeout(() => {
              copyTextElement.classList.remove("show");
            }, 3000);
          }
        })
        .catch((err) => {
          console.error("Failed to copy URL:", err);
        });
    });
  }

  // Blog Page Search Filter JS – multi-instance support
  document.querySelectorAll(".blog__search").forEach(function (searchContainer) {
    const section = searchContainer.closest("section, .main-blog, .shopify-section") || document;
    const inputField = searchContainer.querySelector("#search-blogs, [id^='search-blogs']");
    const clearBtn = searchContainer.querySelector(".blog--search-clear");
    const submitBtn = searchContainer.querySelector("button");
    const blogIdEl = section.querySelector("[id^='blogIdentifyer']") || document.querySelector("[id^='blogIdentifyer']");

    if (!inputField) return;

    const blogIdentifyer = blogIdEl ? blogIdEl.value : "";
    const noResultTexts = blogIdentifyer === "recipe"
      ? '<p>No results found.</p>'
      : '<p>No results found.</p>';

    function getArticlesWrapper() {
      return section.querySelector(".blog-articles") || document.querySelector(".blog-articles");
    }

    function getPagination() {
      return section.querySelector(".pagination-wrapper") || document.querySelector(".main-blog .pagination-wrapper");
    }

    function getAllHiddenArticles() {
      const hiddenContainer = section.querySelector("#all-blog-articles-hidden") || document.querySelector("#all-blog-articles-hidden");
      return hiddenContainer ? hiddenContainer.querySelectorAll(".blog-articles__article") : [];
    }

    function blogPredictiveSearch() {
      const inputVal = inputField.value.trim().toLowerCase();
      const visibleArticlesWrapper = getArticlesWrapper();
      const pagination = getPagination();

      if (!inputVal) {
        fetch(window.location.pathname)
          .then(r => r.text())
          .then(html => {
            const doc = new DOMParser().parseFromString(html, "text/html");
            const freshArticles = doc.querySelector(".blog-articles");
            if (visibleArticlesWrapper && freshArticles) {
              visibleArticlesWrapper.innerHTML = freshArticles.innerHTML;
            }
            if (pagination) pagination.classList.remove("hidden");
            if (clearBtn) clearBtn.style.display = "none";
          });
        return;
      }

      const allArticlesHidden = getAllHiddenArticles();
      let resultHTML = "";
      allArticlesHidden.forEach(article => {
        const title = article.getAttribute("data-title") || "";
        if (title.toLowerCase().includes(inputVal)) {
          resultHTML += article.outerHTML;
        }
      });

      if (visibleArticlesWrapper) {
        visibleArticlesWrapper.innerHTML = resultHTML || noResultTexts;
      }
      if (pagination) pagination.classList.add("hidden");
      if (clearBtn) clearBtn.style.display = "inline-block";
    }

    // Input event – live search + clear button visibility
    inputField.addEventListener("input", function () {
      if (clearBtn) {
        clearBtn.style.display = this.value.length >= 2 ? "block" : "none";
      }
      blogPredictiveSearch();
    });

    // Submit button click
    if (submitBtn) {
      submitBtn.addEventListener("click", function (e) {
        e.preventDefault();
        blogPredictiveSearch();
      });
    }

    // Prevent form submission (Enter key) from reloading the page
    const formEl = searchContainer.closest("form") || searchContainer.querySelector("form") || searchContainer;
    if (formEl && formEl.tagName === "FORM") {
      formEl.addEventListener("submit", function (e) {
        e.preventDefault();
        blogPredictiveSearch();
        inputField.blur();
      });
    }

    // Clear button
    if (clearBtn) {
      clearBtn.addEventListener("click", function () {
        inputField.value = "";
        clearBtn.style.display = "none";
        blogPredictiveSearch();

        // Reset articles from server
        const visibleArticlesWrapper = getArticlesWrapper();
        const pagination = getPagination();
        fetch(window.location.pathname)
          .then(response => response.text())
          .then(responseHTML => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(responseHTML, "text/html");
            const articleGrid = doc.querySelector(".blog-articles");

            if (visibleArticlesWrapper) {
              visibleArticlesWrapper.innerHTML =
                (articleGrid && articleGrid.innerHTML.trim().length > 0)
                  ? articleGrid.innerHTML
                  : noResultTexts;
            }
            if (pagination) pagination.classList.remove("hidden");

            setTimeout(() => { document.activeElement.blur(); }, 100);
          });
      });
    }
  });

  // customer tag add on create customer
  if (
    document.querySelector("#customer-tag") &&
    document.querySelector("#RegisterForm-zipcode")
  ) {
    document
      .getElementById("RegisterForm-zipcode")
      .addEventListener("input", function () {
        var zipcodeValue = document
          .getElementById("RegisterForm-zipcode")
          .value.trim();
        var hiddenTagsInput = document.getElementById("customer-tag");
        if (zipcodeValue) {
          hiddenTagsInput.value =
            "DefaultZip_" + zipcodeValue + "," + "nourish_active";
        } else {
          hiddenTagsInput.value = "";
        }
      });
  }

  // 404 Page Slider
  const fourzeroSlider = document.querySelectorAll(
    ".block__404_shop_collection_col.swiper"
  );
  fourzeroSlider &&
    fourzeroSlider.forEach((four__widget) => {
      new Swiper(four__widget, {
        slidesPerView: 9,
        spaceBetween: 0,
        loop: false,
        navigation: {
          nextEl: ".block__top_collection_next_icon",
          prevEl: ".block__top_collection_prev_icon",
        },
        breakpoints: {
          320: {
            slidesPerView: "2.9",
            spaceBetween: 12,
          },
          569: {
            slidesPerView: "4.5",
            spaceBetween: 12,
          },
          768: {
            slidesPerView: "5.5",
            spaceBetween: 15,
          },
          992: {
            slidesPerView: "6.5",
            spaceBetween: 15,
          },
          1199: {
            slidesPerView: "7.5",
            spaceBetween: 15,
          },
          1300: {
            slidesPerView: "10",
            spaceBetween: 15,
          },
        },
      });
    });

  // Filter click top scroll js

  document.addEventListener("change", function (e) {
    if (e.target.matches('.facets__label input[type="checkbox"]')) {
      // Wait for Shopify's AJAX filtering to finish
      setTimeout(function () {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 500); // Adjust timing as needed
    }
  });
  //collection size variant dropdown js
  const dropdowns = document.querySelectorAll(".custom-dropdown");
  dropdowns.forEach((dropdown) => {
    const selected = dropdown.querySelector(".dropdown-selected");
    const options = dropdown.querySelector(".dropdown-options");
    const items = dropdown.querySelectorAll(".dropdown-options li:not(.disabled)");
    const defaultItem = dropdown.querySelector(".dropdown-options li.selected");
    if (defaultItem) {
      selected.innerHTML = defaultItem.innerHTML;
    }
    selected.addEventListener("click", function (event) {
      event.stopPropagation();
      options.style.display =
        options.style.display === "block" ? "none" : "block";
    });

    items.forEach((item) => {
      item.addEventListener("click", function () {
        const inputEl =
          this.closest(".card__content").querySelector(".variant-id");
        const current_value = this.getAttribute("data-value");
        const productHandle = this.closest(".card-wrapper").getAttribute(
          "data-product-handle"
        );
        const tagContainer =
          this.closest(".card-wrapper").querySelector(".card_product_tag");
        const tagtopContainer = this.closest(".card-wrapper").querySelector(
          ".price_top_tag-metadata"
        );
        const subscription_element = this.closest(
          ".card-wrapper"
        ).querySelector(".product-card-subscription");
        const card_wrapper = this.closest(".card-wrapper");

        if (inputEl.value !== current_value) {
          inputEl.value = current_value;
        }

        selected.innerHTML = this.innerHTML;
        items.forEach((i) => i.classList.remove("selected"));
        this.classList.add("selected");
        options.style.display = "none";

        if (tagContainer || tagtopContainer) {
          fetch(`/products/${productHandle}?variant=${current_value}`)
            .then((res) => res.text())
            .then((html) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, "text/html");
              const newTagContent = doc.querySelector(
                ".card_product-content .card_product_tag"
              );
              const newtopTagContent = doc.querySelector(
                ".card_product-content .price_top_tag-metadata"
              );
              const newsubscription_element = doc.querySelector(
                ".card_product-content .product-card-subscription"
              );

              if (newTagContent && tagContainer) {
                tagContainer.innerHTML = newTagContent.innerHTML;
              }

              if (newtopTagContent && tagtopContainer) {
                tagtopContainer.innerHTML = newtopTagContent.innerHTML;
              }

              if (subscription_element && newsubscription_element) {
                subscription_element.innerHTML =
                  newsubscription_element.innerHTML;

                if (newsubscription_element.innerHTML.trim() !== "") {
                  card_wrapper.classList.add("subscription_card_wrapper");
                } else {
                  card_wrapper.classList.remove("subscription_card_wrapper");
                }
              } else {
                card_wrapper.classList.remove("subscription_card_wrapper");
              }
            });
        }
      });
    });

    document.addEventListener("click", function (event) {
      if (!dropdown.contains(event.target)) {
        options.style.display = "none";
      }
    });
  });

  // Product Card JS
  // document.querySelectorAll(".quantity-selector").forEach(function (selector) {
  //   let decreaseButton = selector.querySelector(".quantity-decrease");
  //   let increaseButton = selector.querySelector(".quantity-increase");
  //   let input = selector.querySelector(".quantity-input");

  //   decreaseButton.addEventListener("click", function () {
  //     if (parseInt(input.value) > 1) {
  //       input.value = parseInt(input.value) - 1;
  //     }
  //   });

  //   increaseButton.addEventListener("click", function () {
  //     input.value = parseInt(input.value) + 1;
  //   });
  // });

  // collection page sub category icon js
  document
    .querySelectorAll(".block__sub_colection_info_icon_wrapper")
    .forEach(function (subicon) {
      let iconCol = subicon.querySelector(
        ".block__sub_collection_info_icon_col"
      );
      let textCol = subicon.querySelector(
        ".block__sub_collection_info_text_col"
      );
      iconCol.addEventListener("click", function () {
        textCol.classList.add("active");
        setTimeout(() => {
          textCol.classList.remove("active");
        }, 3000);
      });
    });

  // Collection page Sub Collection Sec Slider JS
  const subCollectionSlider = document.querySelectorAll(
    ".block__sub_collection_flex_col.swiper"
  );

  subCollectionSlider &&
    subCollectionSlider.forEach((sub_collection) => {
      const swiperInstance = new Swiper(sub_collection, {
        slidesPerView: 5,
        spaceBetween: 0,
        loop: false,
        navigation: {
          nextEl: ".block__sub_collection_next_icon",
          prevEl: ".block__sub_collection_prev_icon",
        },
        breakpoints: {
          320: {
            slidesPerView: 2.5,
            spaceBetween: 6,
          },
          576: {
            slidesPerView: 3,
            spaceBetween: 12,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 13,
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 13,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 13,
          },
          1300: {
            slidesPerView: 5,
            spaceBetween: 13,
          },
        },
      });

      const activeSlide = sub_collection.querySelector(
        ".swiper-slide .active_collection"
      );
      if (activeSlide) {
        const slides = sub_collection.querySelectorAll(".swiper-slide");
        let index = Array.from(slides).findIndex((slide) =>
          slide.contains(activeSlide)
        );
        if (index !== -1) {
          swiperInstance.slideTo(index, 0); // scroll instantly to that slide
        }
      }
    });

  // collection description click for mobile
  document
    .querySelectorAll(".block__collection_page_tab_wrapper")
    .forEach(function (wrapper) {
      const tabItems = wrapper.querySelectorAll(".tab-item");
      const tooltips = wrapper.querySelectorAll(".tooltip");

      tabItems.forEach(function (tabItem) {
        tabItem.addEventListener("click", function (event) {
          const index = this.getAttribute("data-index");
          const tooltipToToggle = wrapper.querySelector(
            `.tooltip[data-index='${index}']`
          );

          if (tooltipToToggle) {
            const isVisible = tooltipToToggle.style.display === "block";
            tooltips.forEach(function (tooltip) {
              tooltip.style.display = "none";
            });

            tooltipToToggle.style.display = isVisible ? "none" : "block";

            // Only add/remove class if screen width is <= 749px
            if (window.innerWidth <= 991) {
              if (!isVisible) {
                document.body.classList.add("overflow-hidden-mobile");
              } else {
                document.body.classList.remove("overflow-hidden-mobile");
              }
            }
          }

          event.stopPropagation();
        });
      });

      tooltips.forEach(function (tooltip) {
        tooltip.addEventListener("click", function (event) {
          event.stopPropagation();
        });

        const closeIcon = tooltip.querySelector(
          ".block__popup_tooltip_close_icon"
        );
        if (closeIcon) {
          closeIcon.addEventListener("click", function (event) {
            tooltip.style.display = "none";
            if (window.innerWidth <= 991) {
              document.body.classList.remove("overflow-hidden-mobile");
            }
            event.stopPropagation();
          });
        }
      });

      document.addEventListener("click", function () {
        tooltips.forEach(function (tooltip) {
          tooltip.style.display = "none";
        });
        if (window.innerWidth <= 991) {
          document.body.classList.remove("overflow-hidden-mobile");
        }
      });
    });

  //How To Order Page Faq Section JS
  document
    .querySelectorAll(".block__faq-accordion-faq-title")
    .forEach((tabFaq) => {
      tabFaq.addEventListener("click", (event) => {
        event.preventDefault();
        const clickedTitle = event.currentTarget;
        const wrapper = clickedTitle.closest(
          ".block__faq-accordion-faq-with-content-wrapper"
        );
        const mainContainer = clickedTitle.closest(
          ".block__section-faq-accordion-content-info"
        );

        if (!wrapper || !mainContainer) return;

        const isActive = wrapper.classList.contains("faq-accordion-faq-active");
        const topBefore = wrapper.getBoundingClientRect().top;

        mainContainer
          .querySelectorAll(".block__faq-accordion-faq-with-content-wrapper")
          .forEach((el) => el.classList.remove("faq-accordion-faq-active"));
        if (!isActive) {
          wrapper.classList.add("faq-accordion-faq-active");

          // Wait for DOM change, then adjust scroll so the clicked stays at same spot
          requestAnimationFrame(() => {
            const topAfter = wrapper.getBoundingClientRect().top;
            const scrollDiff = topAfter - topBefore;
            window.scrollBy({ top: scrollDiff, behavior: "auto" });
          });
        }
      });
    });

  // Blog Listing Popup Filter js
  var buttons = document.querySelectorAll(".block__main_blog_filter_btn_text");
  var target_btn = document.querySelector(".block__main_blog_filter_bg_col");
  var body_add = document.querySelector("body");
  var close_btn = document.querySelector(".block__main_blog_filter_close_btn");
  var popupContent = document.querySelector(".block__main_blog_col");

  if (target_btn) {
    // On Filter Button Click
    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        target_btn.classList.add("show_popup");
        body_add.classList.add("overflow-hidden-mobile");
      });
    });

    // On Close Button Click
    if (close_btn) {
      close_btn.addEventListener("click", function (event) {
        target_btn.classList.remove("show_popup");
        body_add.classList.remove("overflow-hidden-mobile");
        event.stopPropagation(); // Prevent event from bubbling up
      });
    }

    // Click outside to close
    document.addEventListener("click", function (event) {
      if (target_btn.classList.contains("show_popup")) {
        // Check popup is open
        if (
          !popupContent.contains(event.target) &&
          !event.target.closest(".block__main_blog_filter_btn_text")
        ) {
          // If clicked outside popupContent and not on filter button
          target_btn.classList.remove("show_popup");
          body_add.classList.remove("overflow-hidden-mobile");
        }
      }
    });
    // Prevent close when clicking inside the popup content
    popupContent.addEventListener("click", function (event) {
      event.stopPropagation(); // Prevent event from bubbling up to the document
    });
  }

  ///  Account Page Order Accordion js   ///
  const account_accordion = document.querySelectorAll(
    ".block__customer_order_top_col"
  );

  // Open first two sections by default
  account_accordion.forEach((header, index) => {
    if (index < 1) {
      const content = header.nextElementSibling;
      if (
        content &&
        content.classList.contains(
          "block__customer_order_history_accordion_content"
        )
      ) {
        content.style.display = "block";
        header.classList.add("active");
      }
    }
  });

  // Toggle logic
  account_accordion.forEach((header) => {
    header.addEventListener("click", function () {
      const content = this.nextElementSibling;

      if (
        content &&
        content.classList.contains(
          "block__customer_order_history_accordion_content"
        )
      ) {
        const isOpen = content.style.display === "block";
        content.style.display = isOpen ? "none" : "block";
        this.classList.toggle("active", !isOpen);
      }

      account_accordion.forEach((otherHeader) => {
        if (otherHeader !== this) {
          const otherContent = otherHeader.nextElementSibling;
          if (
            otherContent &&
            otherContent.classList.contains(
              "block__customer_order_history_accordion_content"
            )
          ) {
            otherContent.style.display = "none";
            otherHeader.classList.remove("active");
          }
        }
      });
    });
  });

  //waitlist popup js
  const popupLinks = document.querySelectorAll(".product__join-waitlist-btn");
  const modal = document.querySelector(".block_join-waitlist-popup-egg");
  const default_modal = document.querySelector(".block_join-waitlist-popup-default");

  if (modal || default_modal) {
    // Show popup after 10 seconds if not closed in last 2 days
    // if(document.querySelector('.show_signup_popup') && !(document.querySelector('.page_why-join-nourish'))){
    //   setTimeout(function() {
    //     const closedTime = localStorage.getItem("popupClosedTime");
    //     const now = new Date().getTime();
    //     const twoDays = 2 * 24 * 60 * 60 * 1000;

    //     if (!closedTime || now - closedTime > twoDays) {
    //       default_modal.classList.remove("hidden");
    //       document.querySelector(".block_join-waitlist-popup-overlay-default").classList.remove("hidden");
    //     }
    //   }, 10000);
    // }

    // Show popup on button click
    popupLinks.forEach((link) => {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        modal.classList.remove("hidden");
        document.querySelector(".block_join-waitlist-popup-overlay-egg").classList.remove("hidden");
      });
    });

    // Close button default popup
    // document.querySelector(".block_join-waitlist-popup-default .block_join-waitlist_close-popup").addEventListener("click", () => {
    //   default_modal.classList.add("hidden");
    //   document.querySelector(".block_join-waitlist-popup-overlay-default").classList.add("hidden");
    //   localStorage.setItem("popupClosedTime", new Date().getTime());
    //   localStorage.setItem("waitlistThankYouShown", "true");
    // });

    // // Overlay click
    // document.querySelector(".block_join-waitlist-popup-overlay-default").addEventListener("click", () => {
    //   default_modal.classList.add("hidden");
    //   document.querySelector(".block_join-waitlist-popup-overlay-default").classList.add("hidden");
    //   localStorage.setItem("popupClosedTime", new Date().getTime());
    //   localStorage.setItem("waitlistThankYouShown", "true");
    // });

    // Close button egg popup
    document.querySelector(".block_join-waitlist-popup-egg .block_join-waitlist_close-popup").addEventListener("click", () => {
      modal.classList.add("hidden");
      document.querySelector(".block_join-waitlist-popup-overlay-egg").classList.add("hidden");
    });

    // Overlay click
    document.querySelector(".block_join-waitlist-popup-overlay-egg").addEventListener("click", () => {
      modal.classList.add("hidden");
      document.querySelector(".block_join-waitlist-popup-overlay-egg").classList.add("hidden");
    });

  }

  // Account Page Dropdown js
  document.addEventListener("click", function (e) {
    const clicked = e.target.closest(".top-dropdown-item");
    if (clicked) {
      document
        .querySelectorAll(".bottom-dropdown-item")
        .forEach(function (item) {
          item.classList.toggle("is-active");
        });
      clicked.classList.toggle("is-open");
    }
  });

  // ===========  Recharge Bundle Code Start ============= //  
  const initializeObserver = () => {
    const targetNode = document.querySelector("#build-a-box");
    if (!targetNode) {
      return setTimeout(initializeObserver, 500);
    }
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(({ addedNodes }) => {
        if (addedNodes.length > 0) {
          document
            .querySelectorAll(".rb-item-img .rb-img")
            .forEach((imgElement) => {
              if (!imgElement.querySelector(".product_cart_view")) {
                imgElement.insertAdjacentHTML(
                  "beforeend",
                  `
                              <svg width="40" height="40" class="product_cart_view" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 40px;position: absolute;top: auto;top: 20px;right: 20px;">
                                <foreignObject x="-3.2" y="-3.2" width="36.4" height="36.4"><div xmlns="http://www.w3.org/1999/xhtml" style="backdrop-filter:blur(1.6px);clip-path:url(#bgblur_0_11051_60677_clip_path);height:100%;width:100%"></div></foreignObject><circle data-figma-bg-blur-radius="3.2" cx="15" cy="15" r="15" fill="white"/>
                                <path d="M14.9968 8.25C19.0409 8.25 22.4054 11.1598 23.1108 15C22.4054 18.8401 19.0409 21.75 14.9968 21.75C10.9527 21.75 7.58819 18.8401 6.88281 15C7.58819 11.1598 10.9527 8.25 14.9968 8.25ZM14.9968 20.25C18.1735 20.25 20.8918 18.039 21.5799 15C20.8918 11.961 18.1735 9.75 14.9968 9.75C11.82 9.75 9.10175 11.961 8.41367 15C9.10175 18.039 11.82 20.25 14.9968 20.25ZM14.9968 18.375C13.1328 18.375 11.6218 16.864 11.6218 15C11.6218 13.136 13.1328 11.625 14.9968 11.625C16.8607 11.625 18.3718 13.136 18.3718 15C18.3718 16.864 16.8607 18.375 14.9968 18.375ZM14.9968 16.875C16.0323 16.875 16.8718 16.0355 16.8718 15C16.8718 13.9645 16.0323 13.125 14.9968 13.125C13.9613 13.125 13.1218 13.9645 13.1218 15C13.1218 16.0355 13.9613 16.875 14.9968 16.875Z" fill="#E19D9D"/>
                                <defs>
                                <clipPath id="bgblur_0_11051_60677_clip_path" transform="translate(3.2 3.2)"><circle cx="15" cy="15" r="15"/>
                                </clipPath></defs>
                              </svg>
                               
                                `
                );
              }
            });
        }
      });
    });

    observer.observe(targetNode, { childList: true, subtree: true });
  };
  initializeObserver();

  // ===========  Recharge Bundle Code end ============= //
});

// Equal Height Js
function equl(name) {
  let heading = document.querySelectorAll(name);
  let titleHeight = 0;
  heading.forEach((title) => {
    let matchHeight = title.clientHeight;
    if (matchHeight > titleHeight) {
      titleHeight = title.clientHeight;
    }
  });
  heading.forEach((divHeight) => {
    divHeight.style.minHeight = titleHeight + "px";
  });
}
document.addEventListener("DOMContentLoaded", function (event) {
  setTimeout(() => {
    equl(".block__join-club-step-header");
    equl(".block__trusted--families");
    equl(".block_adddress_bg_col");
  }, 500);
});

// card product height set on Window load
function setProductCardHeights() {
  document
    .querySelectorAll(
      ".product-card-wrapper:not(.block_collection_tabify_wrapper .product-card-wrapper)"
    )
    .forEach(function (best_subscription_element) {
      // Reset height first to get accurate new height
      best_subscription_element.style.height = "auto";
      let best_sellerget_Height =
        best_subscription_element.getBoundingClientRect().height;
      best_subscription_element.style.height = best_sellerget_Height + "px";
    });

  if (
    document.querySelector(".page_main-collection") ||
    document.querySelector(".page_main-search") ||
    document.querySelector(".template_collection") ||
    document.querySelector(".page_egg-landing") ||
    document.querySelector(".best_seller_slider_sec")
  ) {
    document.body.classList.add("hide-cursor");
  }
}
setProductCardHeights();

window.addEventListener("load", () => {
  setProductCardHeights();
  setTimeout(() => {
    document.body.classList.remove("hide-cursor");
  }, 200);
});

let lastScrollY = window.scrollY;
let isSticky = false;

window.addEventListener("scroll", function () {
  const target = document.querySelector(".facets-wrapper");
  const header = document.querySelector("sticky-header"); // Adjust selector if needed
  if (!target || !header) return;

  const rect = target.getBoundingClientRect();
  const headerHeight = header.offsetHeight;
  const currentScrollY = window.scrollY;
  const scrollingUp = currentScrollY < lastScrollY;

  // Add sticky: scrolling down and target top hits under header
  if (!isSticky && rect.top <= headerHeight && rect.bottom > headerHeight) {
    target.classList.add("sticky");
    isSticky = true;
  }

  // Remove sticky: only when scrolling UP and scrolled within top 500px
  if (isSticky && scrollingUp && currentScrollY <= 500) {
    target.classList.remove("sticky");
    isSticky = false;
  }

  lastScrollY = currentScrollY;
});

let bloglastScrollY = window.scrollY;
let blogisSticky = false;

window.addEventListener("scroll", function () {
  const blogtarget = document.querySelector(
    ".block__main_blog_search_filter"
  );
  const blogheader = document.querySelector("sticky-header"); // Adjust selector if needed
  if (!blogtarget || !blogheader) return;

  const blogrect = blogtarget.getBoundingClientRect();
  const blogheaderHeight = blogheader.offsetHeight;
  const blogcurrentScrollY = window.scrollY;
  const blogscrollingUp = blogcurrentScrollY < bloglastScrollY;

  // Add sticky: scrolling down and target top hits under header
  if (
    !isSticky &&
    blogrect.top <= blogheaderHeight &&
    blogrect.bottom > blogheaderHeight
  ) {
    blogtarget.classList.add("sticky");
    isSticky = true;
  }

  // Remove sticky: only when scrolling UP and scrolled within top 500px
  if (isSticky && blogscrollingUp && blogcurrentScrollY <= 500) {
    blogtarget.classList.remove("sticky");
    isSticky = false;
  }

  bloglastScrollY = blogcurrentScrollY;
});

// bulk qty js for collection page
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.bulk_purchase_card_wrapper .bulk-container').forEach(container => {
    const selected = container.querySelector('.bulk-purchase-selected');
    const options = container.querySelector('.bulk-purchase-dropdown-options');
    const card = container.closest('.product-card-wrapper');
    const input = card.querySelector('input[name="quantity"]');

    if (!selected || !options || !input) return;
    selected.addEventListener('click', (e) => {
      e.stopPropagation();
      document.querySelectorAll('.bulk-purchase-dropdown-options.show').forEach(opt => {
        if (opt !== options) opt.classList.remove('show');
      });
      options.classList.toggle('show');
    });

    options.querySelectorAll('li.bulk-purchase-dropdown-item').forEach(option => {
      option.addEventListener('click', () => {
        const value = option.getAttribute('data-value');
        const priceElement = option.querySelector('.bulk-purchase-dropdown-price');
        const priceSpan = priceElement?.querySelector('.pp');
        const priceData = priceSpan?.getAttribute('data-price');
        const priceValue = priceElement?.innerHTML;

        selected.querySelector('.bulk-purchase-dropdown-qty').textContent = value;
        selected.querySelector('.bulk-purchase-dropdown-price').innerHTML = priceValue;
        input.value = value;
        options.classList.remove('show');
        const priceTarget = container.closest('.card')?.querySelector('.price__container .price-item--regular');
        if (priceTarget && priceData) {
          priceTarget.textContent = priceData;
        }
      });
    });

    if (card) {
      card.addEventListener('mouseleave', () => {
        options.classList.remove('show');
      });
    }
  });
});

// bulk qty js for cart
document.addEventListener('click', function (e) {
  const selected = e.target.closest('.cart-bulk-purchase-selected');
  if (!selected) return;

  e.stopPropagation();

  const container = selected.closest('.cart-bulk-container');
  const options = container.querySelector('.cart-bulk-purchase-dropdown-options');
  document.querySelectorAll('.cart-bulk-purchase-dropdown-options.show').forEach((el) => {
    if (el !== options) el.classList.remove('show');
  });

  document.querySelectorAll('.cart-bulk-purchase-selected.active').forEach((el) => {
    if (el !== selected) el.classList.remove('active');
  });

  selected.classList.toggle('active');
  options.classList.toggle('show');
});

// Select option (Event Delegation)
document.addEventListener('click', function (e) {
  const option = e.target.closest('.cart-bulk-purchase-dropdown-item');
  if (!option) return;

  const container = option.closest('.cart-bulk-container');
  const selected = container.querySelector('.cart-bulk-purchase-selected');
  const input = container.querySelector('input');

  const value = option.getAttribute('data-value');

  const priceElement = option.querySelector('.cart-bulk-purchase-dropdown-price');
  if (priceElement) {
    const priceSpan = priceElement.querySelector('.pp');
    const priceData = priceSpan?.getAttribute('data-price') || null;
    const priceHTML = priceElement.innerHTML;
    selected.querySelector('.cart-bulk-purchase-dropdown-price').innerHTML = priceHTML;
  }
  selected.querySelector('.cart-bulk-purchase-dropdown-qty').textContent = value;
  input.value = value;

  const lineIndex = input.dataset.index;
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      line: lineIndex,
      quantity: parseInt(value)
    })
  })
    .then(() => {
      updateCartDrawerUI();
    })
    .catch(err => console.error('Cart update error:', err));
  container.querySelector('.cart-bulk-purchase-dropdown-options').classList.remove('show');
  selected.classList.remove('active');

  const priceTarget = container.closest('.cart-item')?.querySelector('.price-item--regular');
  if (priceTarget && priceData) {
    priceTarget.textContent = priceData;
  }
});

// Close dropdown on outside click
document.addEventListener('click', function (e) {
  if (e.target.closest('.cart-bulk-container')) return;

  document.querySelectorAll('.cart-bulk-purchase-selected').forEach(el => {
    el.classList.remove('active');
  });

  document.querySelectorAll('.cart-bulk-purchase-dropdown-options').forEach(el => {
    el.classList.remove('show');
  });
});

function updateCartDrawerUI() {
  const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('.cart-drawer');
  const cartCountBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');

  if (document.querySelector('.template_cart')) {
    refreshCartPage();
  } else {
    fetch('/?section_id=cart-drawer')
      .then(res => {
        if (!res.ok) throw new Error(`Failed to fetch cart drawer: ${res.status}`);
        return res.text();
      })
      .then(html => {
        const tmp = document.createElement('div');
        tmp.innerHTML = html;

        const newDrawer = tmp.querySelector('cart-drawer') || tmp.querySelector('.cart-drawer');
        if (newDrawer && cartDrawer) {
          cartDrawer.innerHTML = newDrawer.innerHTML;
        }

        const newCartCount = tmp.querySelector('#cart-icon-bubble .cart-count-bubble');
        if (newCartCount && cartCountBubble) {
          cartCountBubble.innerHTML = newCartCount.innerHTML;
        } else if (newCartCount && !cartCountBubble) {
          const cartIcon = document.querySelector('#cart-icon-bubble');
          if (cartIcon) cartIcon.appendChild(newCartCount);
        } else if (!newCartCount && cartCountBubble) {
          cartCountBubble.remove();
        }
      })
      .catch(err => console.error('Error updating cart drawer:', err));
  }
}
function refreshCartPage() {
  const sections = [
    {
      id: 'main-cart-items',
      section: document.getElementById('main-cart-items')?.dataset.id,
      selector: '#main-cart-items',
    },
    {
      id: 'main-cart-footer',
      section: document.getElementById('main-cart-footer')?.dataset.id,
      selector: '#main-cart-footer',
    },
  ];

  const sectionIds = sections.map(s => s.section).filter(Boolean);
  fetch(`${routes.cart_url}?sections=${sectionIds.join(',')}`)
    .then(res => res.json())
    .then(data => {
      sections.forEach(section => {
        const html = data[section.section];
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newEl = doc.querySelector(section.selector);
        const oldEl = document.querySelector(section.selector);
        if (newEl && oldEl) {
          oldEl.innerHTML = newEl.innerHTML;
        }
      });
      document.dispatchEvent(new CustomEvent('cart:updated'));
    })
    .catch(err => console.error(err));
}
// bulk qty js for cart